import { useQuery } from 'react-query';
import { CUSTOMER_PHOTOS } from '../../constants/reactQuery.keys';
import CustomerPhotos from '../../services/CustomerPhotos';

const { getCustomerPhotos } = CustomerPhotos;

export function useCustomerPhotos(customerId: number) {
  return useQuery([CUSTOMER_PHOTOS, customerId], () => getCustomerPhotos(customerId), { refetchOnWindowFocus: false });
}
